var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14906",
    "data-name": "Group 14906",
    transform: "translate(-1072 -202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14905",
    "data-name": "Group 14905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35672",
    "data-name": "Path 35672",
    d: "M1089,203.04a1,1,0,0,1-.95,1.052c-.75.04-1.35.089-1.81.138a1.1,1.1,0,0,0-1.07,1,41.81,41.81,0,0,0,0,7.534,1.1,1.1,0,0,0,1.07,1,72.242,72.242,0,0,0,11.52,0,1.1,1.1,0,0,0,1.07-1,41.81,41.81,0,0,0,0-7.534,1.1,1.1,0,0,0-1.07-1c-.46-.049-1.06-.1-1.81-.138a1,1,0,1,1,.1-2c.79.042,1.42.094,1.92.147a3.1,3.1,0,0,1,2.85,2.765,44.388,44.388,0,0,1,0,7.988,3.1,3.1,0,0,1-2.85,2.765,74.064,74.064,0,0,1-11.94,0,3.1,3.1,0,0,1-2.85-2.765,44.388,44.388,0,0,1,0-7.988,3.1,3.1,0,0,1,2.85-2.765c.5-.053,1.13-.1,1.92-.147A1,1,0,0,1,1089,203.04Z",
    transform: "translate(0 17)",
    fill: "#777e91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35673",
    "data-name": "Path 35673",
    d: "M1089.21,199.207a1,1,0,0,1-1.42-1.414l3.5-3.5a1.006,1.006,0,0,1,1.42,0l3.5,3.5a1,1,0,0,1-1.42,1.414l-1.79-1.793V207a1,1,0,0,1-2,0v-9.586Z",
    transform: "translate(0 17)",
    fill: "#777e91",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4547",
    "data-name": "Rectangle 4547",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(1073 203)",
    fill: "none",
    stroke: "#e6e8ec",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.4b98bd029c75c822af47470be02d26f2.svg";
export { ForwardRef as ReactComponent };